<!-- Dialog: Info -->
@if(view && view.canShow['info']) {
  <p-dialog
    header="Detalle del registro"
    [(visible)]="view.canShow['info']"
    (onShow)="scrollToTop()">

    <div [style.width.vw]="80">
      <app-reactive-form-builder
        [form]="form!"
        [serverUrl]="serverUrl"
        [previousData]="previousData"
        (hideDialog)="view.hide('info')">
      </app-reactive-form-builder>
    </div>
  </p-dialog>
}

<!-- Dialog: Delete -->
@if (view && view.canShow['delete']) {
  <p-dialog
    header="Eliminar registro"
    [(visible)]="view.canShow['delete']"
    (onShow)="scrollToTop()">

    <div [style.width.vw]="80">
      <app-reactive-form-builder
        [form]="form!"
        [serverUrl]="serverUrl"
        [previousData]="previousData"
        [recordHasAssociatedData]="recordHasAssociatedData"
        [getRequest]="getRequest"
        [request]="deleteRequest"
        (hideDialog)="view.hide('delete')">
      </app-reactive-form-builder>
    </div>
  </p-dialog>
}

<!-- Dialog: Generate -->
@if (view && view.canShow['generate']) {
  <p-dialog 
    header="Generar Word" 
    [(visible)]="view.canShow['generate']" 
    (onShow)="scrollToTop()">

    <div [style.width.vw]="50" style="min-height: 40vw !important;">
      <app-generate-modal
        [model]="previousData"
        (hideDialog)="view.hide('generate')">
      </app-generate-modal>
    </div>
  </p-dialog>
}

<!-- Dialog: Wizard -->
@if (env.wizard) {
  <app-wizard-modal
    (hideDialog)="view.hide('wizard')">
  </app-wizard-modal>
}